<template>
<div class="image__location--box u__padding">

<div v-if="loading" class="loading__box">
  <div class="loading show">
    <div class="spin"></div>
  </div>
</div>
  <div v-else>
    <div class="image__container"  v-for="(image, imageIndex) in items" :key="imageIndex" @click="open()">
      <div v-if="image.src">
        <div class="icon__glass-container" @click="open()" >
          <font-awesome-icon class="icon__glass" :icon="iconGlass" />
        </div>
        <img class="image__location" :src="image.src" :alt="image.title">
      </div>
      <div v-else>
        <h1>Imagen no disponible</h1>
      </div>
    </div>
  </div>
  <LightBox :items="items" nameLightbox="lightboxIndividual" :openLightBox="model" @closeLightBox="close" />
  <!-- <CoolLightBox
      :items="items"
      :index="index"
      :useZoomBar="true"
      @close="index = null">
  </CoolLightBox> -->

</div>
</template>

<script>
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import {mapActions, mapGetters} from "vuex"
import LightBox from "../../core/lightbox/LightBox.vue"
export default {
  name: "ImageLocation",
  props: ["typeImage", "urlImg"],
  components:{
    LightBox
  },
  data() {
    return{
      planta: true,
      plantaF: false,
      plantaUrl: "https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/casas/modelos/ENCINO.jpeg",
      iconGlass: faMagnifyingGlass,
      baseUrl: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/',
      id: "",
      items: [],
      modelos : [],
      index: null,
      model:false
    }
  },
  computed: {
    ...mapGetters({
      selected : 'getSelectedLocation',
      urlImage: 'getUrlImageLocation',
      loading: 'getStatusLoading'
    }),
    development(){
      return { id: this.id }
    },
    formatImage(){
      let formato;
      if(this.urlImg === 'bosques/casas/modelos'){
        formato = '.png'
      }else{
        formato = '.jpeg'
      }
      return formato;
    },
    typeModel(){
      let src;
      if(this.typeImage === "modeloCasas"){
        src = `https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/${this.urlImg}/${this.selected.type}${this.formatImage}`
      }else if(this.typeImage === "modeloDeptos"){
        src = `https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/${this.urlImg}/${this.selected.imagePrototype}`
      }else if(this.typeImage === 'modeloDeptosTP'){
        src = `${this.urlImg}/${this.selected.imagePrototype}`
      }
      return src
    },


  },
  methods: {
      ...mapActions(["getAvailableImageLocation"]),
      open(){
        this.model= true
      },
      close(){
        this.model=false
      }
  },
 async created(){
   this.id = this.selected.id;
   if(this.typeImage === "terreno"){
     await this.getAvailableImageLocation(this.development);
     this.items.push({
       title: this.selected.name,
       src: this.urlImage && this.urlImage !== '' ? this.urlImage : null
     })
   }else{
     await this.getAvailableImageLocation(this.development);
     this.items.push({
       title: this.selected.name,
       src : this.typeModel
     })
   }
  },
  mounted() {

  },
  beforeDestroy(){

  }
}
</script>

<style>
:root {
  --animate-duration: 250ms;
  --animate-delay: 0.9s;
}
.quick {
  transition-duration: "0ms" !important;
}
</style>